<template>
    <div>
        <v-card raised>
            <v-card-title>
                Permit Sales Report
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :loading="loadingPermitSalesReport" :headers="headers" :items="permitSalesReport" :search="search" class="elevation-1">
                    <template v-slot:item.amount="{ item }">
                        <span class="text-base font-normal">$</span>
                        <span class="text-xl font-bold">{{ item.amount }}</span>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                search: '',
                appURL: process.env.MIX_APP_URL,
                loadingPermitSalesReport: false,
                permitSalesReport: [],
                headers: [
                    { text: 'Issued Date', align: 'left', sortable: true, value: 'issued_date',},
                    { text: 'Employee Or Student', value: 'employee_or_student' },
                    { text: 'Payment Type', value: 'payment_type' },
                    { text: 'Amount', value: 'amount' },
                    { text: 'Permits', value: 'permits' },
                ],
            }
        },
        created() {
            this.fetchPermitSalesReport();
        },
        methods: {
            fetchPermitSalesReport: function () {
                this.loadingPermitSalesReport = true;
                axios.get(this.appURL + '/api/permitsalesreport')
                    .then((response) => {
                        if(response.status === 200)
                        {
                            this.permitSalesReport = response.data;
                        }
                        this.loadingPermitSalesReport = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingPermitSalesReport = false;
                    });
            }
        }
    }
</script>
